/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Message_ReportedInputs */

const en_us2_clubs_message_reported = /** @type {(inputs: Clubs_Message_ReportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reported`)
};

const pt_br2_clubs_message_reported = /** @type {(inputs: Clubs_Message_ReportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denunciada`)
};

const es_419_clubs_message_reported = /** @type {(inputs: Clubs_Message_ReportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denunciado`)
};

const pt_pt2_clubs_message_reported = /** @type {(inputs: Clubs_Message_ReportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denunciada`)
};

const fr_fr2_clubs_message_reported = /** @type {(inputs: Clubs_Message_ReportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signalé`)
};

const de_de2_clubs_message_reported = /** @type {(inputs: Clubs_Message_ReportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeldet`)
};

const it_it2_clubs_message_reported = /** @type {(inputs: Clubs_Message_ReportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnalato`)
};

/**
* | output |
* | --- |
* | "Reported" |
*
* @param {Clubs_Message_ReportedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_message_reported = /** @type {((inputs?: Clubs_Message_ReportedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Message_ReportedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_message_reported(inputs)
	if (locale === "es-419") return es_419_clubs_message_reported(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_message_reported(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_message_reported(inputs)
	if (locale === "de-DE") return de_de2_clubs_message_reported(inputs)
	if (locale === "it-IT") return it_it2_clubs_message_reported(inputs)
	return en_us2_clubs_message_reported(inputs)
});
export { clubs_message_reported as "clubs.message_reported" }